<div class="two-columns-forms">
  <div class="two-columns-forms-body">
    <ng-content select="[body]"></ng-content>
  </div>
  @if (secondPageContent) {
  <div class="two-columns-forms-aux">
    <ng-content select="[aux]"></ng-content>
  </div>
  }
</div>
